export default __webpack_public_path__ + "static/100--stacked-bar-2e777fe7bfc8bf85e4d4fbca761d9e1d.png";